module.exports = __webpack_public_path__ + "img/clover-coin.eb223215.svg";